

















import Vue from 'vue';
export default Vue.extend({
  props: {
    hidden: {
      type: Boolean,
      required: true
    }
  }
});
